import React from "react";

interface Props {
    children: React.ReactNode;
    htmlClassName?: string;
    bodyClassName?: string;
}

export function Shell(props: Props) {
    return (
        <html lang="en" className={props.htmlClassName}>
            <body className={props.bodyClassName}>
                <div id="root">{props.children}</div>
            </body>
        </html>
    );
}
